// eventBus.js
import Vue from 'vue';
const EventBus = new Vue();
export default EventBus;


// WEBPACK FOOTER //
// ./resources/assets/js/common/eventBus.js